
import { useNavigate } from 'react-router-dom';

const calculators = [
  { name: 'Manhattan, NY', path: '/usa/ny/manhattan', state: 'New York', rate: '10.9%', icon: 'ri-building-4-line', noTax: false },
  { name: 'San Francisco, CA', path: '/usa/ca/san-francisco', state: 'California', rate: '12.3%', icon: 'ri-bridge-line', noTax: false },
  { name: 'Austin, TX', path: '/usa/tx/austin', state: 'Texas', rate: '0%', icon: 'ri-music-2-line', noTax: true },
  { name: 'Miami, FL', path: '/usa/fl/miami', state: 'Florida', rate: '0%', icon: 'ri-sun-line', noTax: true },
  { name: 'Chicago, IL', path: '/usa/il/chicago', state: 'Illinois', rate: '4.95%', icon: 'ri-building-2-line', noTax: false },
  { name: 'Seattle, WA', path: '/usa/wa/seattle', state: 'Washington', rate: '0%', icon: 'ri-cloud-line', noTax: true },
  { name: 'Boston, MA', path: '/usa/ma/boston', state: 'Massachusetts', rate: '5.0%', icon: 'ri-book-open-line', noTax: false },
  { name: 'Denver, CO', path: '/usa/co/denver', state: 'Colorado', rate: '4.4%', icon: 'ri-landscape-line', noTax: false },
  { name: 'Atlanta, GA', path: '/usa/ga/atlanta', state: 'Georgia', rate: '5.5%', icon: 'ri-film-line', noTax: false },
  { name: 'Phoenix, AZ', path: '/usa/az/phoenix', state: 'Arizona', rate: '2.5%', icon: 'ri-sun-foggy-line', noTax: false },
  { name: 'London, UK', path: '/uk/london', state: 'United Kingdom', rate: '45%', icon: 'ri-government-line', noTax: false },
  { name: 'Nashville, TN', path: '/usa/tn/nashville', state: 'Tennessee', rate: '0%', icon: 'ri-guitar-line', noTax: true },
];

const PopularCalculators = () => {
  const navigate = useNavigate();

  // Defensive navigation: ensure navigate is a function
  const safeNavigate = (to) => {
    try {
      if (typeof to === 'string' && to.trim() !== '') {
        navigate(to);
      } else {
        console.warn('Attempted to navigate to an invalid path:', to);
      }
    } catch (err) {
      console.error('Navigation error:', err);
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <h2 className="text-3xl font-bold text-gray-900 mb-3">
            <strong>Popular Salary Tax Calculators by City</strong>
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto">
            Instantly calculate your take-home pay in America&apos;s top cities. Each calculator includes federal, state, and local tax breakdowns updated for 2026.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {calculators.map((calc) => (
            <a
              key={calc.path}
              href={calc.path}
              onClick={(e) => {
                e.preventDefault();
                safeNavigate(calc.path);
              }}
              className="group flex items-center gap-4 p-5 bg-gray-50 hover:bg-teal-50 border border-gray-100 hover:border-teal-200 rounded-xl transition-all cursor-pointer hover:-translate-y-0.5 hover:shadow-md"
            >
              <div className="w-11 h-11 flex items-center justify-center bg-white group-hover:bg-teal-500 border border-gray-200 group-hover:border-teal-500 rounded-lg transition-colors flex-shrink-0">
                <i className={`${calc.icon} text-lg text-gray-600 group-hover:text-white transition-colors`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-bold text-gray-900 group-hover:text-teal-700 transition-colors truncate">{calc.name}</h3>
                <div className="flex items-center gap-2 mt-0.5">
                  <span
                    className={`text-xs font-semibold px-1.5 py-0.5 rounded ${
                      calc.noTax ? 'bg-emerald-100 text-emerald-700' : 'bg-gray-100 text-gray-600'
                    }`}
                  >
                    {calc.noTax ? 'No State Tax' : `${calc.rate} top rate`}
                  </span>
                </div>
              </div>
              <i className="ri-arrow-right-s-line text-gray-300 group-hover:text-teal-500 ml-auto flex-shrink-0 transition-colors"></i>
            </a>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="/states"
            onClick={(e) => {
              e.preventDefault();
              safeNavigate('/states');
            }}
            className="inline-flex items-center gap-2 px-6 py-3 bg-gray-900 hover:bg-gray-800 text-white font-medium rounded-xl transition-colors cursor-pointer whitespace-nowrap text-sm"
          >
            <i className="ri-map-pin-line"></i> View All 50 States &amp; 200+ Cities
          </a>
        </div>
      </div>
    </section>
  );
};

export default PopularCalculators;
